import { history } from 'redux-first-router';
import { DEVICE_PLACEHOLDERS } from 'config';
import { AppType } from './constants';
import App from './models/app';

export const getType = (location?: any) => {
  let locationTypeIdentifier;

  if (!location) {
    locationTypeIdentifier = history().location.pathname;
  } else {
     locationTypeIdentifier = location.payload?.appType || '';
  }

  const isApp = locationTypeIdentifier.includes('app');
  const isClock = locationTypeIdentifier.includes('clock');
  const isTile = locationTypeIdentifier.includes('tile');
  const isNeutral = !isApp && !isClock && !isTile;

  let appType = '';
  if(isApp) {
    appType = 'APP'
  }
  if(isTile) {
    appType = 'TILE'
  }
  if(isClock) {
    appType = 'CLOCK'
  }

  return { isApp, isClock, isNeutral, isTile, appType };
}

export const getTypeMapped = (location?: any) => {
  let locationTypeIdentifier;

  if (!location) {
    locationTypeIdentifier = history().location.pathname;
  } else {
    locationTypeIdentifier = location.payload?.appType || '';
  }

  const isApp = locationTypeIdentifier.includes('app');
  const isClock = locationTypeIdentifier.includes('clock');
  const isTile = locationTypeIdentifier.includes('tile');
  const isNeutral = !isApp && !isClock && !isTile;

  let appType = AppType.APP;
  if (isApp) {
    appType = AppType.APP;
  }
  if (isTile) {
    appType = AppType.TILE;
  }
  if (isClock) {
    appType = AppType.CLOCK;
  }

  return { isApp, isClock, isNeutral, isTile, appType };
}

export const calculateHeight = (imgHeight: number, imgWidth: number) => imgHeight / ( imgWidth / 56 );

interface PageTypeParams {
  isApp: boolean;
  isClock: boolean;
  isTile: boolean
}

export const getPageType = (options: PageTypeParams) => {
  if (options.isClock) {
    return 'CLOCK'
  }

  if (options.isTile) {
    return 'TILE'
  }

  return 'APP'
}

export const getResourceType = (options: PageTypeParams) => {
  if (options.isClock) {
    return 'clocks'
  }

  if (options.isTile) {
    return 'tiles'
  }

  return 'apps'
}

// shuffleArray implements the Fisher-Yates (Knuth) Shuffle.
export const shuffleArray = (arr: any[]) => {
  const shuffled = arr.slice();

  let numRemaining = shuffled.length;
  let iRandom;
  while (numRemaining !== 0) {
    // Pick one of the remaining elements.
    iRandom = Math.floor(Math.random() * numRemaining);
    // Swap current last element with the randomly picked element.
    [shuffled[numRemaining - 1], shuffled[iRandom]] = [shuffled[iRandom], shuffled[numRemaining - 1]];
    numRemaining--;
  }

  return shuffled;
}

export const getPremiumIcon = ({ type, isPremium }: App, deviceName?: string) => {
  const deviceData = DEVICE_PLACEHOLDERS[deviceName?.toLowerCase() as keyof typeof DEVICE_PLACEHOLDERS] as any;
  if (!isPremium || !deviceData) {
    return '';
  }

  switch (type) {
    case AppType.TILE.toUpperCase():
      return deviceData.premiumTileIcon || '';
    case AppType.CLOCK.toUpperCase():
      return deviceData.premiumClockIcon || '';
    default:
      return '';
  }
};
